import { translate } from './commonFun'
import { dealTaskLoading } from './plankCommonFuncs'

type defultLifeType = {
  checkData: any
  loadSetting: any
  dealNCData: any
  ncloadPreferences: any
  ncdealTemp: any
  genZip: any
  genPicFile?: any
  genPdfFile?: any
}

/** 翻译函数 只处理标签页翻译 */
function t(k: string, val?: any) {
  return translate('arrangedPage.ncDownloadLifeText.' + k, val)
}

// 创建下载NC执行过程中的生命周期函数
export const initNcLifeObj = (
  that: any,
  hasExport: ('pdf' | 'picture')[],
  isFollowExportTag: boolean
) => {
  /** @description 是否顺带导出 PDF 标签 */
  const isExportPdf = isFollowExportTag && hasExport.includes('pdf')
  /** @description 是否顺带导出 图片 标签 */
  const isExportPic = isFollowExportTag && hasExport.includes('picture')
  const defultLifeObj: defultLifeType = {
    checkData: dealTaskLoading(
      t('checkData'),
      t('checkDone'),
      t('checkDataText'),
      that,
      'taskList'
    ),
    loadSetting: dealTaskLoading(
      t('loadSetting'),
      t('settingLoadDone'),
      t('loadSettingText'),
      that,
      'taskList'
    ),
    dealNCData: dealTaskLoading(
      t('downloadNc'),
      t('ncDownloadDone'),
      t('downloadText'),
      that,
      'taskList'
    ),
    ncloadPreferences: dealTaskLoading(
      t('loadPreferenceSetting'),
      t('PreferenceSettingLoadDone'),
      t('loadPreferenceText'),
      that,
      'taskList'
    ),
    ncdealTemp: dealTaskLoading(
      t('dealTemp'),
      t('TempDealDone'),
      t('dealTempText'),
      that,
      'taskList'
    ),
    genPicFile: isExportPic
      ? dealTaskLoading(
          t('beBeingGenTagFile', { fileType: translate('common.tagImage') }),
          t('genTagFileDone', { fileType: translate('common.tagImage') }),
          t('genTagFileText', { fileType: translate('common.tagImage') }),
          that,
          'taskList'
        )
      : null,
    genPdfFile: isExportPdf
      ? dealTaskLoading(
          t('beBeingGenTagFile', { fileType: translate('common.pdfTag') }),
          t('genTagFileDone', { fileType: translate('common.pdfTag') }),
          t('genTagFileText', { fileType: translate('common.pdfTag') }),
          that,
          'taskList'
        )
      : null,
    genZip: dealTaskLoading(
      t('zip'),
      t('zipDone'),
      t('genZipText'),
      that,
      'taskList'
    ),
  }
  return { ...defultLifeObj }
}
